<script setup>
import { ref, watch, onMounted } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { Slide } from "vue3-burger-menu";
import HeaderSection from "./components/HeaderSection.vue";
import FooterSection from "./components/FooterSection.vue";

const showMenu = ref(true);
const { logout, isAuthenticated } = useAuth0();

const initialize = () => {
  showMenu.value = isAuthenticated.value;
};
onMounted(() => initialize());

const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};

watch(
  () => isAuthenticated.value,
  (status) => {
    showMenu.value = isAuthenticated.value;
  },
  () => props.userLocation,
  (newLoc) => {
    if (newLoc) {
      fetchUKWeather();
    }
  },
  { immediate: true } // Runs immediately when the prop becomes available
);

</script>

<template>
  <div id="app">
    <Slide no-overlay :burger-icon="showMenu">
      <img src="../src/assets/images/blything-mobile-menu-logo.png" />
      <a id="home" href="#">
        <font-awesome-icon :icon="['fas', 'house']" /><span>Home</span>
      </a>
      <a id="profile" href="#/profile">
        <font-awesome-icon :icon="['fas', 'user']" /><span>Profile</span>
      </a>
      <a id="logout" @click="handleLogout">
        <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" /><span>Logout</span>
      </a>
    </Slide>
    <div id="page-stretch">
      <div id="header">
        <HeaderSection />
      </div>

      <div id="page-content" class="grid-x grid-padding-x">
        <router-view />
      </div>
    </div>

    <div id="footer" class="footer">
      <FooterSection />
    </div>
  </div>
</template>

<style lang="scss">
@import "./assets/styles/main.scss";
</style>